import { PATH_DELIMITER, FIND_ID_PW_PATH } from '../../../constant/Constant';
import { createAction, handleActions } from 'redux-actions';
import { call, put, takeEvery } from '@redux-saga/core/effects';
import { request } from '../../ApiModule';

const ACTION_FIND_ID = FIND_ID_PW_PATH + PATH_DELIMITER + 'ACTION_FIND_ID';
const ACTION_REQ_PASSWORD_RESET = FIND_ID_PW_PATH + PATH_DELIMITER + 'ACTION_REQ_PASSWORD_RESET';
const HANDLE_FIND_ID = FIND_ID_PW_PATH + PATH_DELIMITER + 'HANDLE_FIND_ID';
const HANDLE_FIND_PW = FIND_ID_PW_PATH + PATH_DELIMITER + 'HANDLE_FIND_PW';

export const actionFindId = createAction(ACTION_FIND_ID);
export const actionReqPasswordReset = createAction(ACTION_REQ_PASSWORD_RESET);

export function* findIdPwSagas() {
    yield takeEvery(ACTION_FIND_ID, actionFindIdSaga);
    yield takeEvery(ACTION_REQ_PASSWORD_RESET, actionReqPasswordResetSaga);
}

function* actionFindIdSaga({ payload: { email, callback } }) {
    const userId = email;
    const findIdResult = yield call(request, {
        method: 'get',
        url: `/api/users/${userId}/exists`,
    });

    if (findIdResult != undefined) {
        callback && callback(findIdResult);
    }
}

function* actionReqPasswordResetSaga({ payload: { data, callback } }) {
    const findPwResult = yield call(request, {
        method: 'post',
        url: '/api/email/reset-password',
        data,
        callback,
    });

    if (findPwResult != undefined) {
        yield put({
            type: HANDLE_FIND_PW,
            payload: {
                findPwResult,
            },
        });
    }
}

const initialState = {
    findPwResult: false,
};

const module = handleActions(
    {
        [HANDLE_FIND_PW]: (state, { payload: findPwResult }) => ({ ...state, ...findPwResult }),
    },
    initialState,
);

export default module;
